import React from 'react';

const ServerContentEmpty = () => {
    return (
        <div className='server_content_wraper'>
            <div className='server_plug_img'></div>
            <div className='server_plug_name'></div>
            <div className='server_plug_folower'></div>
            <div className='server_plug_info-owner'></div>
        </div>
    );
};

export default ServerContentEmpty;